import { create } from 'zustand';

export type FlashKind = 'success' | 'error' | 'info';

export interface FlashMessage {
  id: number;
  kind: FlashKind;
  message: string;
}

interface FlashState {
  messages: FlashMessage[];
  show: (kind: FlashKind, message: string) => void;
  dismiss: (id: number) => void;
}

export const useFlashStore = create<FlashState>((set) => ({
  messages: [],
  show: (kind, message) => {
    const id = Date.now() + Math.random();
    set(state => ({ messages: [...state.messages, { id, kind, message }] }));
  },
  dismiss: (id) => set(state => ({ messages: state.messages.filter(m => m.id !== id) })),
}));
